import { Provider } from '@angular/core';
import { provideState } from '@ngrx/store';

import * as fromProfile from './profile';

export function provideProfileState(): Provider {
  return [provideState(fromProfile.featureKey, fromProfile.reducer)];
}
